// The chemstyle tables. Moved out of `utils/index.ts` so modules that need them
// (e.g. `chemStyleAccelerate.ts`) can import them without going through the
// barrel, which would import them back — the barrel re-exports everything here,
// so consumers see no change.
export const chemStyleIds = [
    250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264,
    265, 266, 267, 268, 269, 270, 271, 272, 273,
];
export const chemStyleCategories = {
    Basic: [250],
    Attacking: [251, 254, 252, 253, 266, 255],
    Midfielder: [258, 256, 257, 261, 257, 259, 260, 267],
    Defending: [264, 268, 261, 262, 263, 265],
    Goalkeeper: [270, 273, 269, 272, 271],
};
export const chemStyles = {
    250: "BASIC",
    251: "SNIPER",
    252: "FINISHER",
    253: "DEADEYE",
    254: "MARKSMAN",
    255: "HAWK",
    256: "ARTIST",
    257: "ARCHITECT",
    258: "POWERHOUSE",
    259: "MAESTRO",
    260: "ENGINE",
    261: "SENTINEL",
    262: "GUARDIAN",
    263: "GLADIATOR",
    264: "BACKBONE",
    265: "ANCHOR",
    266: "HUNTER",
    267: "CATALYST",
    268: "SHADOW",
    269: "WALL",
    270: "SHIELD",
    271: "CAT",
    272: "GLOVE",
    273: "BASIC",
};
export const chemStylesToIcon = {
    250: "\uE033",
    251: "\uE044",
    252: "\uE038",
    253: "\uE036",
    254: "\uE03F",
    255: "\uE03C",
    256: "\uE031",
    257: "\uE030",
    258: "\uE040",
    259: "\uE03E",
    260: "\uE037",
    261: "\uE041",
    262: "\uE03B",
    263: "\uE039",
    264: "\uE032",
    265: "\uE02F",
    266: "\uE03D",
    267: "\uE035",
    268: "\uE042",
    269: "\uE045",
    270: "\uE043",
    271: "\uE034",
    272: "\uE03A",
    273: "\uE033",
};
//# sourceMappingURL=chemStyles.js.map